/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const TimeOnly = zod.object({
  "hour": zod.number().optional(),
  "minute": zod.number().optional(),
  "second": zod.number().optional(),
  "millisecond": zod.number().optional(),
  "microsecond": zod.number().optional(),
  "nanosecond": zod.number().optional(),
  "ticks": zod.number().optional()
});

export type TimeOnly = zod.input<typeof TimeOnly>;
export type TimeOnlyOutput = zod.output<typeof TimeOnly>;
